<template>
  <b-nav-item-dropdown
    v-if="isDropdown"
    :text="label"
    :class="modifiers"
    :right="isRight"
    :active-class="activeClass"
    no-caret
  >
    <template
      v-for="(item, idx) in children"
    >
      <b-dropdown-item
        v-if="typeof item.onClick === 'function' && !item.hidden"
        :key="idx"
        @click="item.onClick"
      >
        {{ item.label || `Item ${idx+1}` }}
      </b-dropdown-item>
      <b-dropdown-item
        v-else-if="!item.hidden"
        :key="idx"
        :to="item.link"
      >
        {{ item.label || `Item ${idx+1}` }}
      </b-dropdown-item>
    </template>
  </b-nav-item-dropdown>
  <b-nav-item
    v-else
    :to="link || '#'"
    :active="isActive"
  >
    {{ label || 'Link' }}
  </b-nav-item>
</template>
<script>
export default {
  name: 'Nav',
  props: {
    label: String,
    modifiers: String,
    link: [String, Object],
    active: Boolean,
    right: Boolean,
    activeClass: {
      type: String,
      default: 'active',
    },
    children: {
      type: Array,
      default: () => ([]),
    },
  },
  computed: {
    isDropdown() {
      return this.children.length;
    },
    isActive() {
      return Boolean(this.active);
    },
    isRight() {
      return Boolean(this.right);
    },
  },
};
</script>
